<template>
    <Grid/>
</template>

<script>
    import Grid from './../components/Competences/Grid'

    export default {
        components: {
            Grid,
        }
    }
</script>